import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { createDispatchers } from "@utils/dispatcher";
import { RootState } from "..";

export interface DataAvailabilityPreviewState {
  dashboardId: string | null;
  datasetId: string | null;
  previewDate: string | null;
  isActive: boolean;
}

export const initialState: DataAvailabilityPreviewState = {
  dashboardId: null,
  datasetId: null,
  previewDate: null,
  isActive: false,
};

export const dataAvailabilityPreviewSlice = createSlice({
  name: "dataAvailabilityPreview",
  initialState,
  reducers: {
    applyDataAvailabilityPreview: (
      state,
      action: PayloadAction<{
        dashboardId: string;
        datasetId: string;
        previewDate: string;
      }>,
    ) => {
      state.dashboardId = action.payload.dashboardId;
      state.datasetId = action.payload.datasetId;
      state.previewDate = action.payload.previewDate;
      state.isActive = true;
    },
    endDataAvailabilityPreview: () => initialState,
    resetDataAvailabilityPreviewForDashboard: (
      state,
      action: PayloadAction<{ dashboardId: string }>,
    ) => {
      if (
        state.dashboardId &&
        state.dashboardId !== action.payload.dashboardId
      ) {
        return initialState;
      }
      return state;
    },
  },
});

export const {
  applyDataAvailabilityPreview,
  endDataAvailabilityPreview,
  resetDataAvailabilityPreviewForDashboard,
} = dataAvailabilityPreviewSlice.actions;

export const dataAvailabilityPreviewDispatcher = createDispatchers(
  dataAvailabilityPreviewSlice.actions,
);

export const dataAvailabilityPreviewSelector = (state: RootState) =>
  state.dataAvailabilityPreview;

export const dataAvailabilityPreviewReducer =
  dataAvailabilityPreviewSlice.reducer;
